import React from 'react'
import { BiPlayCircle } from 'react-icons/bi'
import { Link } from 'react-router-dom'

const AboutContent = () => {
  return (
    <>
      <section class="space-ptb">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 mb-4 mb-lg-0 pr-xl-6">
            <div class="section-title mb-4">
              <h2 class="title text-start">Welcome to Pioneer Montessori Inter College</h2>
              <p class="lead mb-0">Pioneer Montessori Inter College stands for Perfection, Innovation, Open-Mindedness, Nationalism, Education, Excellence, and Rejuvenation. The strength to pursue our dreams comes from six decades of rich experience, the pride of producing achievers, and the motivation to use education as a means to transform society. In these times, when strong winds of erosive culture are sweeping away the pillars of our moral and social values, Pioneer Montessori Inter College lends strength to the social and family fabric by blending the right values with education. We believe that while we should adopt what is good in other cultures, we must not be swept off our feet.</p>
            </div>
            <Link to={'/About'} class="btn btn-primary btn-round">Read More</Link>
          </div>
          <div class="col-lg-6 pr-lg-5">
            <div class="row">
              <div class="col-sm-7">
                <img class="img-fluid w-100 border-radius" src="/images/about/aboutnew-1.png" alt="" />
              </div>
              <div class="col-sm-5 mt-sm-5 mt-4">
                <img class="img-fluid mb-sm-2 w-100 border-radius" src="/images/gallery/building-3.png" alt="" />
                <div class="position-relative bg-overlay-black-50 border-radius overflow-hidden mt-4">
                  <img class="img-fluid mb-sm-2 w-100 border-radius" src="/images/gallery/building-4.png" alt="" />
                  <Link class="btn-animation position-center" target="_blank" to={'https://youtu.be/STeSbLdhwN8?si=QormdMZFIyfyC3vf'}>
                      <BiPlayCircle size={80} className='text-white' />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}

export default AboutContent
